<!-- begin:: Header Mobile -->
<div id="kt_header_mobile" class="kt-header-mobile">
	<div class="kt-header-mobile__brand">
		<a class="kt-header-mobile__logo" routerLink="/">
			<img alt="logo" class="header_mob_logo" [attr.src]="headerLogo" />
		</a>
	</div>
	<div class="kt-header-mobile__toolbar">
		<button
			[hidden]="!asideDisplay"
			class="kt-header-mobile__toggler kt-header-mobile__toggler--left"
			id="kt_aside_mobile_toggler"
			style="background: transparent; border: none; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; padding: 4px;"
		>
			<i class="la la-bars" style="font-size: 1.8rem; color: #ffffff; display: block;"></i>
		</button>
	</div>
</div>
<!-- end:: Header Mobile -->
